export const SET_CURRENT_BUSINESS = "SET_CURRENT_BUSINESS";

export const SET_IS_LOADING = "SET_IS_LOADING";
export const SET_IS_MODAL_LOADING = "SET_IS_MODAL_LOADING";

export const SET_IS_MOBILE_MENU_OPEN = "SET_IS_MOBILE_MENU_OPEN";
export const SET_POPUP = "SET_POPUP";
export const SET_TZUR_POPUP = "SET_TZUR_POPUP";
export const SET_OTP = "SET_OTP";
export const SET_HASH = "SET_HASH";
export const SET_TZUR_POPUP_CENTER = "SET_TZUR_POPUP_CENTER";
export const SET_NOTIFICATION = "SET_NOTIFICATION";
export const RESET_STORE = "RESET_STORE";
export const SET_LOOKUP_DATA = "SET_LOOKUP_DATA";
export const SET_OPEN_BIOMETRIC_AS_DEFAULT = "SET_OPEN_BIOMETRIC_AS_DEFAULT"

export const SET_IS_ADMIN = "SET_IS_ADMIN";
export const SET_SELECTED_MONTH_GLOBAL = "SET_SELECTED_MONTH_GLOBAL";

export const SET_IS_MOBILE_APP = "SET_IS_MOBILE_APP";
export const SET_MOBILE_APP_WRAPPER_DATA = "SET_MOBILE_APP_WRAPPER_DATA";
export const SET_RECAPTCHA = "SET_RECAPTCHA";
export const SET_PAGE_TYPE = "SET_PAGE_TYPE";

export const SET_IS_MOBILE = "SET_IS_MOBILE";
export const SET_IS_IPHONE = "SET_IS_IPHONE";

export const SET_T_DATA = "SET_T_DATA";
export const SET_SETTINGS = "SET_SETTINGS";
export const SET_CONFIG = "SET_CONFIG";

export const SET_SINGLE_REVIEW_PAGE = "SET_SINGLE_REVIEW_PAGE";
export const SET_REVIEWS_PAGE_DATA = "SET_REVIEWS_PAGE_DATA";
export const RESET_REVIEWS_PAGE_DATA = "RESET_REVIEWS_PAGE_DATA";

export const SET_ADMIN_OTP_LOGIN_TEMP_DATA = "SET_ADMIN_OTP_LOGIN_TEMP_DATA";

export const SET_DELIVIARY_ORDERS = "SET_DELIVIARY_ORDERS";
export const SET_FROM_LOGINPAGE = "SET_FROM_LOGINPAGE";
